import PropTypes from 'prop-types';

const ProfileTabContent = props => {
  if (!props.isVisible) {
    return null;
  }

  return props.children;
};

ProfileTabContent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

export default ProfileTabContent;
